import { useEffect, useState, useCallback } from 'react';
import api from '../lib/api';
import { useAuth } from '../lib/auth';

/**
 * Polling del conteo de crons stale (Health Check).
 * Refresca cada 60s y al volver a foco de la pestaña.
 * Solo dispara fetch si hay usuario logueado.
 */
export function useHealthStaleCount() {
  const { user } = useAuth();
  const [count, setCount] = useState(0);

  const fetchCount = useCallback(async () => {
    if (!user) return;
    try {
      const res = await api.get('/health/schedulers');
      setCount(Number(res.data?.stale_count || 0));
    } catch {
      setCount(0);
    }
  }, [user]);

  useEffect(() => {
    if (!user) return;
    fetchCount();
    const interval = setInterval(fetchCount, 60000);
    const onFocus = () => fetchCount();
    window.addEventListener('focus', onFocus);
    return () => {
      clearInterval(interval);
      window.removeEventListener('focus', onFocus);
    };
  }, [user, fetchCount]);

  return count;
}
